import React from 'react';
import styled from 'styled-components';
import { ReactComponent as PlayIcon } from '../img/play.svg';
import { ReactComponent as PauseIcon } from '../img/pause.svg';

// The small round play/pause button over a thumbnail: a compact post's, and
// each item's in the list composer. Its parent must be position: relative.

const Button = styled.button<{ $size: number }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  border-radius: 50%;
  border: 1.5px solid white;
  background: rgba(0, 0, 0, 0.4);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  font-size: 8px;

  /* A larger tap target than the visible circle. */
  &::after {
    content: '';
    position: absolute;
    inset: -9px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export type ThumbPlayState = 'idle' | 'loading' | 'playing' | 'paused';

interface ThumbPlayButtonProps {
  state: ThumbPlayState;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  size?: number;
}

export default function ThumbPlayButton(props: ThumbPlayButtonProps) {
  const size = props.size || 20;
  const icon = Math.round(size * 0.4);
  return (
    <Button
      type="button"
      $size={size}
      onClick={props.onClick}
      disabled={props.disabled}
      aria-label={props.state === 'playing' ? 'Pause' : 'Play'}
      aria-busy={props.state === 'loading'}
    >
      {props.state === 'loading' ? (
        '...'
      ) : props.state === 'playing' ? (
        <PauseIcon width={icon} height={icon} style={{ color: 'white' }} />
      ) : (
        <PlayIcon width={icon} height={icon} style={{ color: 'white' }} />
      )}
    </Button>
  );
}
